module.exports = __webpack_public_path__ + "images/hb11x5.84c7.png";